import { application } from "./application"

import AutosubmitController from "./autosubmit_controller"
import BoardController from "./board_controller"
import ClientContextController from "./client_context_controller"
import ClipboardController from "./clipboard_controller"
import ComposerController from "./composer_controller"
import DropzoneController from "./dropzone_controller"
import HotkeysController from "./hotkeys_controller"
import LightboxController from "./lightbox_controller"
import SidebarController from "./sidebar_controller"
import ToastController from "./toast_controller"

application.register("autosubmit", AutosubmitController)
application.register("board", BoardController)
application.register("client-context", ClientContextController)
application.register("clipboard", ClipboardController)
application.register("composer", ComposerController)
application.register("dropzone", DropzoneController)
application.register("hotkeys", HotkeysController)
application.register("lightbox", LightboxController)
application.register("sidebar", SidebarController)
application.register("toast", ToastController)
